import {crmApi} from 'sources/api';
import CrmContact from 'records/CrmContact';
import urlWithParams from 'utils/urlWithParams';
import cancelIfSending from 'sources/cancelIfSending';
import {List} from 'immutable';

const CrmContactSource = cancelIfSending({
  searchContacts(term, cancelConfig) {
    const url = urlWithParams('/search/contacts', {term});
    return crmApi
      .get(url, cancelConfig)
      .then(({data: entities}) => List(entities).map(entity => new CrmContact(entity)));
  },

  fetchContact(id) {
    return crmApi.getJson(`/contacts/${id}`).then(contact => new CrmContact(contact));
  },
});

export default CrmContactSource;
